module.exports = __webpack_public_path__ + "img/DS820A4PP_Large.cb4b4eb3.jpg";